import React from 'react'
import { Link } from 'react-router-dom'

const TopHashtagItem2 = ({Product}) => {
  return (
    <Link to={'/hashtag/'+Product.hashtag}>
        <div className='top_hashtag_button'>
            <p>{"#"+Product.hashtag}</p>
        </div>
    </Link>
  )
}

export default TopHashtagItem2
